.alignRight {
  text-align: right;
}
